import { render } from "./MetadataVariableCodes.vue?vue&type=template&id=a820cbfc&scoped=true"
import script from "./MetadataVariableCodes.vue?vue&type=script&lang=js"
export * from "./MetadataVariableCodes.vue?vue&type=script&lang=js"

import "./MetadataVariableCodes.vue?vue&type=style&index=0&id=a820cbfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a820cbfc"]])

export default __exports__